import { fetchWrapper } from '../../utils/request';
import { endpoint } from './endpoint';
import { SortDirections } from './API';

export function getProducts(
  sortKey: string = 'name',
  sortDir: SortDirections = SortDirections.asc,
  getOnlyConfirmedProducts: boolean = true,
) {
  let sort = [];
  if (sortKey && sortDir) {
    sort.push(sortKey);
    sort.push(sortDir);
  }
  return fetchWrapper(
    endpoint +
      `/v1/products` +
      `?sort=${JSON.stringify(sort)}` +
      `&get_only_confirmed_products=${getOnlyConfirmedProducts ? '1' : '0'}`,
  ).then((res) => res.json());
}

export function getShopifyProducts() {
  return fetchWrapper(endpoint + `/v1/shopify/products`).then((res) =>
    res.json(),
  );
}

export function addProduct(product: Object) {
  return fetchWrapper(endpoint + `/v1/products`, {
    method: 'post',
    body: JSON.stringify(product),
  }).then((res) => res.json());
}

export function updateProduct(id: string, updates: Object) {
  return fetchWrapper(endpoint + `/v1/products/` + id, {
    method: 'put',
    body: JSON.stringify(updates),
  });
}
